<template>
    <area-chart
        id="bankrollHistory"
        :data="areaData"
        xkey="date"
        :resize="true"
        ykeys='["balance"]'
        :labels='labels'
        lineColors='["#409da0"]'
        hideHover="auto"
        :parseTime="false"
        :lineWidth="1"
        :pointSize="3"
        fillOpacity="0.4"
        grid="true"
        gridTextFamily="Muli"
        gridTextColor="#65708B"
        :yLabelFormat="money"
    >
    </area-chart>
</template>

<script>
import { AreaChart } from 'vue-morris'

export default {
    components: {
        AreaChart
    },
    props: ['areaData', 'currency'],
    data() {
        return {
            labels: [
                this.__('HomeBalance')
            ]
        }
    },
    methods: {
        money(value) {
            return this.currency + ' ' + value;
        }
    }
}
</script>

<style>

</style>
